const getMessageString = (intl, text) => intl.formatMessage({ id: text, defaultMessage: text });

const NOT_AUTHENTICATED_EVENT = "not_authenticated";

const NOT_AUTHORIZED_EVENT = "not_authorized";

const GATEWAY_ERROR = "gatewayError";

export { getMessageString, NOT_AUTHENTICATED_EVENT, NOT_AUTHORIZED_EVENT, GATEWAY_ERROR };
